module.exports = __webpack_public_path__ + "img/redalerti.044563a6.svg";